// Not actual, see /middleware/history.js

// export default function({ from, route }) {
//   if (from && from.fullPath && from.name && from.name.indexOf('category-url') === -1) {
//     const prevRoute = from.fullPath;
//     const encodedRoute = btoa(encodeURIComponent(prevRoute)); // Encoding to Base64

//     localStorage.setItem('encodedRoute', encodedRoute);
//   }
// }
